<template>
  <div class="exhibition">
    <div class="exhibition-header">
      <el-image :src="require('../../assets/image/header/headerlogo.png')" fit="cover"></el-image>
      <el-button @click="$router.go(-1)" type="primary">
        <svg class="icon" data-v-68df9b26="" height="18" p-id="2705" t="1644387434751" version="1.1" viewBox="0 0 1024 1024" width="18" xmlns="http://www.w3.org/2000/svg">
          <path d="M475.591111 300.373333V175.217778c-11.377778-52.337778-54.613333-20.48-54.613333-20.48L120.604444 411.875556c-65.991111 45.511111-4.551111 79.644444-4.551111 79.644444l295.822223 254.862222c59.164444 43.235556 63.715556-22.755556 63.715555-22.755555v-116.053334C775.964444 514.275556 898.844444 887.466667 898.844444 887.466667c11.377778 20.48 18.204444 0 18.204445 0 116.053333-559.786667-441.457778-587.093333-441.457778-587.093334z"
                data-v-68df9b26=""
                fill="" p-id="2706"></path>
        </svg>
        返回
      </el-button>
    </div>
    <div class="exhibition-operation">
      <div class="operation-title">{{ title}}</div>
      <div class="operation-Button">
        <el-button :class="viewshow == 1?'is-active':''" @click="changeSlave(1)" class="all" v-show="onlyshow==1">翻译对照</el-button>
        <el-button :class="viewshow == 2?'is-active':''" @click="changeSlave(2)" class="base" v-show="onlyshow==1 || onlyshow==2 ">只显示底本</el-button>
        <el-button :class="viewshow == 3?'is-active':''" @click="changeSlave(3)" class="tran" v-show="onlyshow==1 || onlyshow==3">只显示译本</el-button>
      </div>
    </div>
    <div class="exhibition-main">
      <div :class="mainswich?'open':'close'" class="exhibition-left">
        <retrieval :book-id="pageId" :class="changejuks.berfor?'retopen':'retclose'" ref="retopen" v-if="changejuks.berfor"></retrieval>
        <catalogue :slave-page="slavePage" :class="changejuks.catabefor?'cataopen':'cataclose'" :slave-data="slaveData" ref="catalogue" v-if="changejuks.catabefor && slaveT"></catalogue>
        <notes :book-id="pageId" :class="changejuks.notesfor?'notesaopen':'notesclose'" ref="notes" v-if="changejuks.notesfor"></notes>
        <div :class="changejuks.berfor?'is-active':''" @click="catSwich('berfor',changejuks.berfor)" class="exhibition-left-pub exhibition-ret"></div>
        <div :class="changejuks.catabefor?'is-active':''" @click="catSwich('catabefor',changejuks.catabefor)" class="exhibition-left-pub exhibition-cat"></div>
        <div :class="changejuks.notesfor?'is-active':''" @click="catSwich('notesfor',changejuks.notesfor)" class="exhibition-left-pub exhibition-notes"></div>

        <div @click="changePage(pageindex-1,false,true)" class="exhibition-bottom-left"></div>

      </div>
      <div class="exhibition-view" style="height: 100%;">
        <div :class="viewshow!=1?'comit':''" class="exhibition-views" style="height: 100%;">
          <div class="exhibition-views-item" v-if="viewshow == 1 || viewshow ==3">
            <div class="views-item-title">译本</div>
            <div class="views-item-image" ref="tranref" style="height: calc(100% - 1.2rem);">
              <el-image :src="transUrl" fit="contain"></el-image>
            </div>
          </div>
          <div class="exhibition-views-item" style="height: 100%;" v-show="viewshow == 1 || viewshow ==2">
            <div class="views-item-title">底本</div>
            <div class="views-item-image" ref="viewcanvas" style="height: calc(100% - 1.2rem);">
              <el-image :src="baseUrl" fit="contain" v-show="baseUrl!=''"></el-image>
              <!-- <CanvasIndex :img-url="baseUrl" v-show="baseUrl!=''" width="" height=""></CanvasIndex> -->
              <el-empty :image-size="200" description="暂无底本资源" style="height:100%;padding-bottom: 0;margin-bottom: 1.563rem;" v-show="baseUrl==''"></el-empty>
            </div>
          </div>
        </div>
      </div>
      <div class="exhibition-right">
        <div @click="changePage(pageindex+1,true,true)" class="exhibition-bottom-right"></div>
        <div class="exhibition-right-lanmu">
          <div class="exhibition-right-box">
            <div class="exhibition-right-flex">
              <el-image :src="require('../../assets/image/details/detail_bd.png')" fit="fill"></el-image>
              <div class="exhibition-right-title">相关古籍</div>
            </div>
            <div @click="gjIs_active=!gjIs_active" class="exhibition-right-more">more <i :class="gjIs_active?'is-active':''" class="el-icon-d-arrow-right"></i></div>
          </div>
          <div :class="gjIs_active?'is-active':''" class="exhibition-right-main">
            <div :key="index" class="main-box" v-for="(item, index) in bookData" @click.stop="$router.push({path:'/resource/detail',query:{bookId:item.bookId}})">
              <div class="main-image">
                <el-image :src="item.imgPath=='/'?require('../../assets/image/index/book.png'):item.imgPath" fit="cover"></el-image>
              </div>
              <div class="main-title">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="exhibition-right-lanmu">
          <div class="exhibition-right-box">
            <div class="exhibition-right-flex">
              <el-image :src="require('../../assets/image/details/detail_bd.png')" fit="fill"></el-image>
              <div class="exhibition-right-title">相关视频</div>
            </div>
            <div @click="viIs_active=!viIs_active" class="exhibition-right-more">more <i :class="viIs_active?'is-active':''" class="el-icon-d-arrow-right"></i></div>
          </div>
          <div :class="viIs_active?'is-active':''" class="exhibition-right-main videos">
            <div :key="index" class="main-box" v-for="(item, index) in videoData" @click.stop="$router.push({path:'/resource/videoshows',query:{bookId:item.bookId}})">
              <div class="videos-image">
                <el-image :src="item.imgPath == '/'?require('../../assets/image/index/video_image.png'):item.imgPath.replace('/home/uftp/books','/fileBookWeb')" fit="cover"></el-image>
              </div>
              <div class="main-title">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="exhibition-right-lanmu">
          <div class="exhibition-right-box">
            <div class="exhibition-right-flex">
              <el-image :src="require('../../assets/image/details/detail_bd.png')" fit="fill"></el-image>
              <div class="exhibition-right-title">相关音频</div>
            </div>
            <div @click="auIs_active=!auIs_active" class="exhibition-right-more">more <i :class="auIs_active?'is-active':''" class="el-icon-d-arrow-right"></i></div>
          </div>
          <div :class="auIs_active?'is-active':''" class="exhibition-right-main audiose">
            <div :key="index" class="main-box" v-for="(item, index) in audioData"  @click.stop="$router.push({path:'/resource/detailsAud',query:{bookId:item.bookId}})">
              <div class="aodio-image">
                <el-image :lazy="true" :src="item.imgPath == '/'?require('../../assets/image/resource/pic-audio.jpg'):item.imgPath" fit="fill"></el-image>
              </div>
              <div class="main-title">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import retrieval from '@/components/exhibition/retrieval'
  import catalogue from '@/components/exhibition/catalogue'
  import notes from '@/components/exhibition/notes.vue'
  import CanvasIndex from '../../components/canvas/index.vue'

  import {getReferencePage, listRelationByBookIdFileName, view} from '@/api/exhibition'
  import {getMasterSlaveCatalogue,getBookById} from '@/api/resource'

  export default {
    name: 'PortalIndex',
    components: {
      retrieval, catalogue, notes, CanvasIndex
    },
    data() {
      return {
        //控制页面
        mainswich: true,
        changejuks: {
          // 控制检索
          berfor: false,
          // 控制目录
          catabefor: true,
          // 控制注释
          notesfor: false,
        },
        // 底本目录
        baseslaveData: [],
        // 译本目录
        translaveData: [],
        // 传入目录
        slaveData: [],
        // 控制 view 显示
        /**
         * @viewshow
         * 1：翻译对照
         * 2：只显示底部
         * 3：只显示译本
         */
        viewshow: 1,
        /**
         * @onlyshow
         * 1：全部显示
         * 2：显示底本
         * 3：显示译本
         */
        onlyshow: 1,

        // 译本图片
        imagesindex: '',
        imageList: [],
        // 底本资源
        base: {},
        // 译本资源
        translation: {},
        // 底本照片
        baseUrl: '',
        baseServe: '',
        // 译本照片
        transUrl: '',
        transServe: '',
        // 底本id
        baseBookId: '',
        // 译本id
        transBookId: '',
        // 当前index
        pageindex: '',
        baseIndex: '',

        gjIs_active: false,
        viIs_active: false,
        auIs_active: false,

        bookData: [],
        videoData: [],
        audioData: [],
        title: '',
        pageId: '',
        // 用于目录控制绑定
        slavePage:{
          baseId:'',
          basePage:0,
          transId:'',
          transPage:'',
          judge:'1'
        },
        slaveT:false,
        zdUrl:'',
        trueUrl:''
      };
    },
    created() {
      this.init()
    },
    mounted() {
      // this.getview()
      // this.getMast()
    },

    methods: {
      getBook(id){
        return new Promise((provide,reject)=>{
          getBookById({
            bookId:id
          }).then(res=>{
            if(res.data.code == 200 && res.data.data){
              provide(res.data.data.find(e=>e.captions == '图片路径').attributeValue.replace('/home/uftp/books/','/fileBookWeb/'))
            }
          })
        })
      },
      async init() {
        let that = this
        let data = await this.getReferencePages()
        this.base = data.base
        this.translation = data.translation[0]
        if (this.base) {
          this.baseBookId = this.base.bookId
          this.baseServe = this.base.serverBase
        }
        if (this.translation) {
          this.transBookId = this.translation.bookId
          this.transServe = this.translation.serverBase
          this.title = this.translation.title
          let dd =await this.getBook(this.transBookId)
          this.zdUrl = dd
        } else {
          this.title = this.base.title
        }

        // 底本没有走这里
        if (data.base == null) {
          this.onlyshow = 3
          this.viewshow = 3
          this.pageId = this.translation.bookId
          this.slavePage.transId =  this.translation.bookId
          this.slavePage.transPage = 0
          this.translaveData = [this.slaveDataFun(this.translation)]
          this.slaveData = this.translaveData
          this.slavePage.judge = 1
          if (this.translation.images) {
            // this.transUrl = this.transServe + '/thumbnails/' + this.translation.images[0] + '/large.jpg'
            this.transUrl = this.zdUrl+'/' + this.translation.images[0] + '.jpg'
            // this.computs(this.translation.images[0])
          }
          this.getRelation(this.translation.bookId, this.translation.images[0])
        } else if (Object.keys(data.translation).length == 0) {
          // 译本没有，走这里
          this.onlyshow = 2
          this.viewshow = 2
          this.pageId = this.base.bookId
          this.slavePage.baseId =  this.base.bookId
          this.slavePage.basePage = 0
          this.baseslaveData = [this.slaveDataFun(this.base)]
          this.slaveData = this.baseslaveData
          this.slavePage.judge = 2
          if (this.base.images) {
            this.baseUrl = this.baseServe + '/thumbnails/' + this.base.images[0] + '/large.jpg'
            // this.computs(this.base.images[0])
            this.getRelation(this.base.bookId, this.base.images[0])
          }
        } else {
          this.pageId = this.translation.bookId
          this.slavePage.baseId =  this.base.bookId
          this.slavePage.transId =  this.translation.bookId
          this.slavePage.transPage = 0
          this.baseslaveData = [this.slaveDataFun(this.base)]
          this.translaveData = [this.slaveDataFun(this.translation)]
          this.slaveData = this.translaveData
          this.slavePage.judge = 1
          this.trueUrl = this.translation.images[0]
          this.computs(this.translation.images[0])
          this.getRelation(this.base.bookId, this.translation.images[0])
        }
        this.pageindex = 0
        // 主从目录
        // const promises = [this.baseBookId, this.transBookId].map(function (bookId) {
        //   return that.getMast(bookId)
        // });
        // const [baseData, transData] = await Promise.all(promises)
        this.slaveT = true
        /**
         * 底本译本都有目录，且两者都存在 用译本
         * 底本有，译本无，用底本
         * 底本无，译本有，用译本
         *
         */
      },
      slaveDataFun(data,type){
        let arr = []
        data.images.forEach((e,index) => {
          let obj = {
            id:index,
            page:index+1,
            description:index+1
          }
          arr.push(obj)
        });
        let obj = {
          bookId: data.bookId,
          bookName:data.title,
          catalogues:arr
        }
        return obj
      },
      computs(item) {
        // this.transUrl = this.transServe + '/thumbnails/' + item + '/large.jpg'
        this.transUrl = this.zdUrl+'/' + item + '.jpg'
        if (item.split("_").length < 2) {
          this.baseUrl = ''
        } else {
          if(this.base){
            const dd = this.base.images.findIndex((e)=>e == item.split("_")[0] )
            if(dd!=-1){
              this.slavePage.basePage = dd
            }else{
              this.slavePage.basePage = 0
            }
          }
          this.baseUrl = this.baseServe + '/thumbnails/' + item.split("_")[0] + '/large.jpg'
        }
      },
      // this.$parent.changePage(items.page-1, true, false)
      async changePage(index, i, to) {
        if(this.viewshow == 1 || this.viewshow == 3){
            if (index < 0 || index >= this.translation.images.length) {
            return
          } else {
            this.slavePage.transPage = index
            this.trueUrl = this.translation.images[index]
            this.computs(this.translation.images[index])
            this.pageindex = index
            this.getRelation(this.translation.bookId, this.translation.images[index])
          }
        }else if(this.viewshow == 2){
            this.trueUrl = ''
            let indexs = 0
            // 判断是否为目录点击 false 目录
            if (to) {
              indexs = this.base.images.indexOf(this.baseUrl.split('thumbnails/')[1].split('/large.jpg')[0])
              if (i) {
                indexs++
              } else {
                indexs--
              }
            } else {
              indexs = index
            }
            if (indexs < 0 || indexs >= this.base.images.length) {
              return
            } else {
              this.baseIndex = indexs
              this.slavePage.basePage = indexs
              if(this.translation){
                let ssd = JSON.parse(JSON.stringify(this.translation.images))
                const dd = ssd.findIndex((e)=>e.split("_")[0]+'_' == this.base.images[this.baseIndex]+'_' )
                if(dd!=-1){
                  this.slavePage.transPage = dd
                }else{
                  this.slavePage.transPage = 0
                }
              }
              this.baseUrl = this.baseServe + '/thumbnails/' + this.base.images[this.baseIndex] + '/large.jpg'
              this.getRelation(this.base.bookId, this.base.images[this.baseIndex] )
            }
        }
      },
      catSwich(name, judge) {
        // 优化处理逻辑
        if (this.mainswich) {
          for (const key in this.changejuks) {
            this.changejuks[key] = false
          }
          this.changejuks[name] = !judge
        }
        // if(this.mainswich && this.catabefor){
        //     this.mainswich = false
        // }else if(!this.mainswich && this.catabefor){
        //     this.mainswich = true
        // }else if(this.mainswich && !this.catabefor){
        //     this.catabefor = true
        //     this.berfor = false
        // }else if(!this.mainswich && !this.berfor){
        //     this.mainswich = true
        //     this.catabefor = true
        // }else if(!this.mainswich){
        //     if(this.berfor){
        //         this.mainswich = true
        //         this.catabefor = true
        //         this.berfor = false
        //     }
        // }
      },
      // mainSwich
      handClose() {
        this.mainswich = false
      },
      getview() {
        view({
          bookId: this.$route.query.bookId,
          typeId: this.$store.state.typeId
        }).then(res => {
          if (res.data.code == 200 && res.data.data) {
            // this.imageList = Array(res.data.data.images.length).fill(null)
            this.imageList = []
            let serverBase = res.data.data.serverBase
            res.data.data.images.forEach(e => {
              let obj = {
                url: serverBase + '/thumbnails/' + e + '/large.jpg'
              }
              this.imageList.push(obj)
            });
            this.imagesindex = this.$route.query.page
          }
        })
      },
      getMast(bookId) {
        return new Promise((provide, inject) => {
          getMasterSlaveCatalogue({
            bookId: bookId,
            typeId: this.$store.state.typeId
          }).then(res => {
            if (res.data.code == 200 && res.data.data) {
              provide(JSON.parse(JSON.stringify(res.data.data)))
            } else {
              provide([])
            }
          })
        })

      },
      views() {
        this.getview()
      },
      getReferencePages() {
        return new Promise((provide, inject) => {
          getReferencePage({
            typeId: this.$store.state.typeId,
            bookId: this.$route.query.bookId
          }).then(res => {
            if (res.data.code == 200) {
              provide(res.data.data)
            }
          })
        })

      },
      changeSlave(slave) {
        this.slavePage.judge = slave
        if (slave == 1 || slave == 3) {
          if (this.viewshow == 2) {
            this.pageindex = this.slavePage.transPage
            let url =''
            if(this.trueUrl == ''){
              url = this.translation.images.find((e) => {
                return e.split("_")[0] == this.baseUrl.split('thumbnails/')[1].split('/large.jpg')[0]
              })
            }else{
              url = this.trueUrl
            }
            // this.transUrl = this.transServe + '/thumbnails/' + url + '/large.jpg'
            this.transUrl = this.zdUrl+'/' + url + '.jpg'
          }
          this.slaveData = []
          this.slaveData = this.translaveData
          this.viewshow = slave
        } else if (slave == 2) {
          if (this.baseUrl == '') {
            this.$message({
              message: "当前页暂无底本资源",
              type: "error",
            });
            return
          }
          this.viewshow = slave
          this.slaveData = []
          this.slaveData = this.baseslaveData
          this.pageindex = this.slavePage.basePage
          // this.slaveData = JSON.parse(JSON.stringify(this.baseslaveData))
        }
      },
      getRelation(bookId, fileName) {
        listRelationByBookIdFileName({
          typeId: this.$store.state.typeId,
          bookId: bookId,
          fileName: fileName
        }).then(res => {
          if (res.data.code == 200) {
            this.bookData = res.data.data.book
            this.videoData = res.data.data.video
            this.audioData = res.data.data.audio
          }
        })

      }

    },
    watch: {
      '$route.query.bookId': {
        handler: function (news, old) {
          this.views(news.path)
        },
        deep: true
      }
    }
  };
</script>
<style lang="less" scoped>
  .exhibition {
    box-sizing: border-box;
    font-family: SimSun;
    // height: 100%;
    display: flex;
    flex-direction: column;
    min-width: 1880px;

    .exhibition-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 2.083rem;
      height: 4.167rem;
      background-color: #ffffff;
      background-image: url('../../assets/image/header/header_bg.png');
      background-repeat: no-repeat;
      background-size: cover;

      .el-image {
        width: 14.01rem;
        height: 2.188rem;
      }

      .el-button {
        height: 1.875rem;
        border-radius: 0.313rem;
        background: #ffffff;
        display: flex;
        align-items: center;
        padding: 8px 15px;
        font-size: 18px;
        color: #582800;
        border-color: #582800;
        vertical-align: -3px;

        &:hover {
          opacity: .8;
        }

        svg {
          margin-right: 3px;
          font-size: 1.2em;
          vertical-align: -3px;

          path {
            fill: #582800 !important;
          }
        }
      }
    }

    .exhibition-operation {
      width: 100%;
      height: 2.604rem;
      background-color: #feedc8;
      padding-left: 1.563rem;
      display: flex;
      align-items: center;

      .operation-title {
        font-size: 1.146rem;
        font-weight: bold;
        color: #582800;
      }

      .operation-Button {
        flex: 1;
        display: flex;
        justify-content: center;

        .el-button {
          margin-right: 2.064rem;
          font-size: 0.729rem;

          &:last-child {
            margin-right: 0;
          }

          &:hover {
            opacity: .8;
          }
        }

        .all, .base, .tran {
          box-sizing: border-box;
          height: 1.458rem;
          line-height: 0;
          background-color: #feedc8;
          border-radius: 0.208rem;
          font-size: 0.729rem;
          padding: 9px 0.833rem;
          border: solid 0.052rem #582800;
          color: #582800;

          &.is-active {
            background-color: #582800;
            border-color: #582800;
            color: #ffffff;
          }
        }
      }
    }

    .exhibition-main {
      flex: 1;
      display: flex;
      .exhibition-left {
        position: relative;
        display: flex;
        box-shadow: 0 8px 10px -5px rgb(0 0 0 / 20%), 0 0px 18px 0px rgb(0 0 0 / 14%), 0 15px 13px -3px rgb(0 0 0 / 12%);

        &.close {
          transition: transform .3s;
          transform: translate(-100%);
          // .catalogue{

          // }
        }

        &.open {
          animation: opens .3s;
        }

        @keyframes opens {
          0% {
            transform: translate(-100%);
          }

          100% {
            transform: translate(0);
          }
        }

        .retopen, .cataopen, .notesaopen {
          display: block;
        }

        .retclose, .cataclose, .notesclose {
          display: none;
        }

        .exhibition-left-pub {
          position: absolute;
          width: calc(3.021rem / 2);
          height: 3.49rem;
          background-color: #cecece;
          border-top-right-radius: 0.417rem;
          border-bottom-right-radius: 0.417rem;
          font-size: 0.833rem;
          color: #ffffff;

          &.exhibition-ret, &.exhibition-cat, &.exhibition-notes {
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            box-sizing: border-box;
            right: -1.5105rem;
            z-index: 1;
            cursor: pointer;

            &.is-active {
              background-color: #feedc8;
              color: #582800;
            }

            &::before {
              height: 40px;
              text-align: justify;
              text-justify: distribute-all-lines;
              text-align-last: justify;
            }
          }

          &.exhibition-ret {
            top: 2.064rem;

            &::before {
              content: '检索';
              position: absolute;
              writing-mode: tb-rl;
              text-align: center;
              display: inline-block;
            }
          }

          &.exhibition-cat {
            top: 6.564rem;

            &::before {
              content: '目录';
              position: absolute;
              writing-mode: tb-rl;
              text-align: center;
            }
          }

          &.exhibition-notes {
            top: calc(6.564rem + 5.064rem);

            &::before {
              content: '注释';
              position: absolute;
              writing-mode: tb-rl;
              text-align: center;
            }
          }
        }

        .exhibition-bottom-left {
          cursor: pointer;
          position: absolute;
          right: -2.064rem;
          top: calc(11.628rem + 8rem);
          height: 6.25rem;
          width: 2.064rem;
          background-color: #cecece;
          border-top-right-radius: 0.729rem;
          border-bottom-right-radius: 0.729rem;
          font-size: 2rem;
          font-family: element-icons !important;
          font-style: normal;
          font-weight: 800;
          font-variant: normal;
          text-transform: none;
          display: inline-block;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;

          &::before {
            content: '\e6de';
          }
        }
      }

      .exhibition-view {
        padding: 1.563rem 4rem;
        flex: 1;
        .exhibition-views {
          &.comit {
            grid-template-columns: 1fr;
            justify-content: center;
            padding: 0 2rem;
          }

          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 3.125rem;
          justify-content: space-around;

          .exhibition-views-item {

            .views-item-title {
              text-align: center;
              margin-bottom: 0.625rem;
              height: 1.2rem;
              box-sizing: border-box;
            }

            .views-item-image {
              min-height: 37.5rem;
              box-sizing: border-box;
              box-shadow: 0 8px 10px -5px rgb(0 0 0 / 20%), 0 0px 18px 0px rgb(0 0 0 / 14%), 0 15px 13px -3px rgb(0 0 0 / 12%);
              display: flex;
              justify-content: center;
              align-items: center;
              max-height: 47.23958333333333rem;
              /deep/ .el-image{
                height: 47.23958333333333rem;
              }
            }
          }
        }
      }

      .exhibition-right {
        width: 15.625rem;
        min-width: 14.625rem;
        // height: 49.479rem;
        box-shadow: 0 8px 10px -5px rgb(0 0 0 / 20%), 0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%);
        position: relative;
        padding: 1.042rem;

        .exhibition-bottom-right {
          cursor: pointer;
          position: absolute;
          left: -2.064rem;
          top: calc(11.628rem + 8rem);
          // transform: translate(0, -50%);
          height: 6.25rem;
          width: 2.064rem;
          background-color: #cecece;
          border-top-left-radius: 0.729rem;
          border-bottom-left-radius: 0.729rem;
          font-size: 2rem;
          font-family: element-icons !important;
          font-style: normal;
          font-weight: 800;
          font-variant: normal;
          text-transform: none;
          display: inline-block;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;

          &::before {
            content: '\e6e0';
          }

        }

        .exhibition-right-lanmu {
          margin-bottom: 2.135rem;

          &:last-child {
            margin-bottom: 0;
          }

          .exhibition-right-box {
            display: flex;
            border-bottom: 0.052rem solid #dddddd;
            padding-bottom: 0.365rem;
            padding-right: .6rem;
            justify-content: space-between;

            .exhibition-right-flex {
              display: flex;
              align-items: center;

              .exhibition-right-title {
                margin-left: 0.313rem;
                font-size: 0.833rem;
                color: #b1222b;
              }
            }

            .exhibition-right-more {
              font-size: 1rem;
              color: #b1222b;
              font-weight: 800;
              cursor: pointer;

              i {
                transition: transform .3s;
                transform: rotateZ(90deg);
              }

              i.is-active {
                transform: rotateZ(-90deg);
              }
            }
          }

          .exhibition-right-main {
            max-height: 13.604rem;
            overflow: hidden;
            cursor: pointer;
            .main-box {
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            &.is-active {
              max-height: none;
            }

            .main-image {
              width: 7.292rem;
              height: 10rem;
            }

            .main-title {
              color: red;
              margin-top: 1rem;
            }
          }

          .exhibition-right-main.audiose {
            max-height: 13.604rem;
            overflow: hidden;

            &.is-active {
              max-height: none;
            }

            .main-box {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 1rem;

              .aodio-image {
                width: 9.375rem;
                height: 9.375rem;
                cursor: pointer;

                .el-image {
                  position: relative;

                  &::after {
                    content: '';
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background: url('../../assets/image/resource/video_logo.png') no-repeat;
                    z-index: 2;
                    width: 50px;
                    height: 50px;
                    opacity: .6;
                  }

                  &::before {
                    content: '';
                    position: absolute;
                    box-shadow: inset 0 0 300px 100px #000;
                    width: 100%;
                    height: 100%;
                    opacity: .6;
                  }
                }

                &:hover {
                  .el-image::after {
                    opacity: 1;
                  }

                  .el-image::before {
                    opacity: .7;
                  }
                }
              }

              .main-title {
                padding-top: 0.729rem;
                overflow: hidden;
                text-overflow: ellipsis; //多出部分用...代替
                display: -webkit-box; //定义为盒子模型显示
                -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
                -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
              }
            }
          }

          .exhibition-right-main.videos {
            max-height: 11.604rem;
            overflow: hidden;

            &.is-active {
              max-height: none;
            }

            .main-box {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 1rem;

              .videos-image {
                cursor: pointer;
                 width: 9.375rem;
                height: 9.375rem;
                .el-image {
                  position: relative;

                  &::after {
                    content: '';
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    background: url('../../assets/image/resource/video_logo.png') no-repeat;
                    z-index: 2;
                    width: 50px;
                    height: 50px;
                    opacity: .6;
                  }

                  &::before {
                    content: '';
                    position: absolute;
                    box-shadow: inset 0 0 300px 100px #000;
                    width: 100%;
                    height: 100%;
                    opacity: .6;
                  }
                }

                &:hover {
                  .el-image::after {
                    opacity: 1;
                  }

                  .el-image::before {
                    opacity: .7;
                  }
                }
              }

              .main-title {
                padding-top: 0.729rem;
                overflow: hidden;
                text-overflow: ellipsis; //多出部分用...代替
                display: -webkit-box; //定义为盒子模型显示
                -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
                -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
              }
            }
          }
        }
      }
    }
  }
</style>
